var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedPadlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1792_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5V5C3.75 2.23867 5.98828 0 8.75 0C11.5117 0 13.75 2.23867 13.75 5V7.5H14.375C16.1016 7.5 17.5 8.89844 17.5 10.625V16.875C17.5 18.6016 16.1016 20 14.375 20H3.125C1.39922 20 0 18.6016 0 16.875V10.625C0 8.89844 1.39922 7.5 3.125 7.5H3.75ZM5 7.5H12.5V5C12.5 2.92891 10.8203 1.25 8.75 1.25C6.64453 1.25 5 2.92891 5 5V7.5ZM1.25 16.875C1.25 17.9102 2.08945 18.75 3.125 18.75H14.375C15.4102 18.75 16.25 17.9102 16.25 16.875V10.625C16.25 9.58984 15.4102 8.75 14.375 8.75H3.125C2.08945 8.75 1.25 9.58984 1.25 10.625V16.875Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1792_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedPadlock);
export default __webpack_public_path__ + "static/media/locked_padlock.a8363b64418dd08d79d3298b3313cb64.svg";
export { ForwardRef as ReactComponent };